<template>
  <div class="TreeItem" :class="[(current && current === node.urlSlug) ? 'TreeItem_Activate' : '', 'Level_' + level]">
    <div class="ItemContent" 
      :style="{ paddingLeft: (level * 15 + 10) + 'px' }"
      :draggable="true"
      @dragstart.stop="HandleDragStart($event, node)"
      @dragover.prevent="HandleDragOver($event, node)"
      @dragenter.prevent="isDragOver = true"
      @dragleave.prevent="ResetDragState"
      @drop.stop.prevent="HandleDrop($event, node)"
      :class="{ 
        'DragOver_Top': isDragOver && dropPosition === 'top',
        'DragOver_Inside': isDragOver && dropPosition === 'inside',
        'DragOver_Bottom': isDragOver && dropPosition === 'bottom'
      }"
      v-contextmenu="{ name: 'FileListMenu' }"
      @contextmenu.stop="$emit('contextmenu', $event, node)"
      @click.stop="HandleClick">
      
      <div class="Icon">
        <img v-if="node.type === 0" src="/icon/folder_new.svg" style="width: 18px; height: 18px;">
        <i v-else class="iconfont icon-markdown" style="color: #e2696c;"></i>
      </div>

      <div class="Info">
        <div class="NodeName">
          <span v-if="node.fileState && node.fileState.state" class="FileState"></span>
          <span>{{ node.nodeName }}</span>
        </div>
      </div>

      <div v-if="node.type === 0" class="Arrow" :class="{ 'Arrow_Expanded': expanded }" @click.stop="HandleClick">
        <img src="/icon/arrow_right.svg" style="width: 12px; height: 12px;">
      </div>
    </div>

    <!-- 子节点递归渲染 -->
    <div v-if="node.type === 0 && expanded" class="Children">
      <template v-if="node.children && node.children.length > 0">
        <TreeItem v-for="child in node.children" 
          :key="child.id" 
          :node="child" 
          :level="level + 1"
          :current="current"
          @click="$emit('click', $event)"
          @node-move="$emit('node-move', $event)"
          @contextmenu="(e, n) => $emit('contextmenu', e, n)">
        </TreeItem>
      </template>
      <div v-else class="EmptyHint" :style="{ paddingLeft: (level * 15 + 35) + 'px' }">
        暂无内容
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeItem',
  props: {
    node: { type: Object, required: true },
    level: { type: Number, default: 0 },
    current: { type: [String, Number] }
  },
  data() {
    return {
      expanded: false,
      isDragOver: false,
      dropPosition: '' // 'top', 'inside', 'bottom'
    }
  },
  methods: {
    ResetDragState() {
      this.isDragOver = false
      this.dropPosition = ''
    },
    HandleClick() {
      if (this.node.type === 0) {
        this.expanded = !this.expanded
        console.log('Folder clicked, expanded:', this.expanded)
      } else {
        console.log('File clicked:', this.node.nodeName)
      }
      this.$emit('click', this.node)
    },
    HandleDragStart(event, node) {
      event.dataTransfer.setData('nodeId', node.id)
      event.dataTransfer.effectAllowed = 'move'
    },
    HandleDragOver(event) {
      this.isDragOver = true
      const rect = event.currentTarget.getBoundingClientRect()
      const offset = event.clientY - rect.top
      
      // 如果是文件夹，支持“移入” (中间 50% 区域)
      if (this.node.type === 0) {
        if (offset < rect.height * 0.25) {
          this.dropPosition = 'top'
        } else if (offset > rect.height * 0.75) {
          this.dropPosition = 'bottom'
        } else {
          this.dropPosition = 'inside'
        }
      } else {
        // 如果是文件，只支持“上方”或“下方”
        if (offset < rect.height * 0.5) {
          this.dropPosition = 'top'
        } else {
          this.dropPosition = 'bottom'
        }
      }
      event.dataTransfer.dropEffect = 'move'
    },
    HandleDrop(event, targetNode) {
      const sourceId = event.dataTransfer.getData('nodeId')
      const position = this.dropPosition
      this.ResetDragState()
      
      if (sourceId && sourceId != targetNode.id) {
        this.$emit('node-move', {
          sourceId: parseInt(sourceId),
          targetNode: targetNode,
          position: position // 'top', 'inside', 'bottom'
        })
      }
    }
  }
}
</script>

<style scoped>
.TreeItem {
  color: var(--ccs-primary-font-color);
  user-select: none;
}

.ItemContent {
  display: flex;
  align-items: center;
  height: 36px;
  cursor: pointer;
  transition: background 0.2s;
}

.ItemContent:hover {
  background: #f0f0f0;
}

.TreeItem_Activate .ItemContent {
  background: #e6f7ff;
  color: var(--ccs-primary-color);
}

.ItemContent.DragOver_Inside {
  background: #e6f7ff !important;
  outline: 2px dashed #f3d16b;
}

.ItemContent.DragOver_Top {
  border-top: 2px solid #f3d16b;
}

.ItemContent.DragOver_Bottom {
  border-bottom: 2px solid #f3d16b;
}

.Icon {
  width: 24px;
  display: flex;
  justify-content: center;
}

.Info {
  flex: 1;
  overflow: hidden;
  padding: 0 5px;
}

.NodeName {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.FileState {
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background: #e2696c;
  margin-right: 5px;
}

.Arrow {
  width: 30px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  color: #999;
  opacity: 0.7;
}

.Arrow:hover {
  color: var(--ccs-primary-color);
  opacity: 1;
}

.Arrow_Expanded {
  transform: rotate(90deg);
}

.Children {
  overflow: visible;
}
.EmptyHint {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #666;
  font-style: italic;
}
</style>
